// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_d9-3";
export var flatBottomCorners = "_d9-5";
export var productImage = "_d9-0";
export var quantityContainer = "_d9-2";
export var quantityHeader = "_d9-6";
export var tooltip = "_d9-1";
export var wrapAndEllipsesOverflow = "_d9-4";